import clsx from 'clsx';
import { DefaultButton, colors } from 'design-system';
import { makeStyles, createStyles, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    titleText: {
      fontSize: '25px',
      fontWeight: 900,
    },
    infoText: {
      fontSize: '20px',
      fontWeight: 400,
      color: colors.abbey,
      marginBottom: 20,
    },
    supportText: {
      fontSize: '18px',
      fontWeight: 400,
      color: colors.abbey,
    },
    email: {
      textDecoration: 'underline',
    },
  }),
);
type Props = {
  onReload: () => void;
  finishTime: string;
};

const DesktopMaintenanceLayout = ({
  onReload,
  finishTime,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="center" alignItems="center" direction="row">
      <Grid item xs={12} lg={10} xl={8} container>
        <Grid item xs={6}>
          <img alt="maintenance-figure" src="/svg/maintenance-figure.svg" />{' '}
        </Grid>
        <Grid
          container
          item
          xs={6}
          direction="column"
          justifyContent="space-around"
        >
          <Grid container item>
            <Grid item xs={12}>
              <Typography className={classes.titleText}>
                Nos encontramos en mantenimiento
              </Typography>
            </Grid>
          </Grid>
          <Grid container item>
            <Grid item xs={12}>
              <Typography className={classes.infoText}>
                Estaremos de regresos a las {` ${finishTime}`}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <DefaultButton
                data-testid="refresh-button"
                variant="outlined"
                onClick={onReload}
              >
                refrescar página
              </DefaultButton>
            </Grid>
          </Grid>
          <Grid container item>
            <Grid item xs={12}>
              <Typography className={classes.supportText}>
                Para consultas contacta a soporte técnico:
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography className={clsx(classes.email, classes.supportText)}>
                soporteventasautocr@assanet.com
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DesktopMaintenanceLayout;
